var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"success"}})],1)]:_vm._e(),(!_vm.loading)?_c('VueUnity',{staticClass:"pl-8 unity-canvas pt-8 rounded-0",attrs:{"unity":_vm.unityContext,"width":'100%',"height":'50vh'}}):_vm._e(),_vm._v(" "),_c('br'),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }